var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"invoicenoCode"},[_c('topHead',[_c('h3',{attrs:{"slot":"header"},on:{"click":_vm.go},slot:"header"},[_vm._v("实名验证")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }